import { render, staticRenderFns } from "./SkeltonDetailsBlog.vue?vue&type=template&id=3a8c5644&scoped=true&"
import script from "./SkeltonDetailsBlog.vue?vue&type=script&lang=js&"
export * from "./SkeltonDetailsBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8c5644",
  null
  
)

export default component.exports